import React from "react";
import { makeStyles } from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import tokens from "../designTokens";

const useStyles = makeStyles({
  group: { background: tokens.track, padding: 3, borderRadius: tokens.radiusInput },
  btn: {
    border: "none",
    borderRadius: tokens.radiusDefault,
    padding: "0 16px",
    height: 32,
    textTransform: "none",
    fontFamily: tokens.fontBody,
    fontSize: 12.5,
    fontWeight: 400,
    color: tokens.textSecondary,
    "&.Mui-selected": {
      color: tokens.primary,
      fontWeight: 600,
      background: tokens.surface,
      boxShadow: "0 1px 2px rgba(10,71,76,0.12)",
    },
    "&.Mui-selected:hover": { background: tokens.surface },
  },
});

// Grey track, white active segment — ToggleButtonGroup dressed like the
// original segmented control.
export default function SegmentedControl({ options = [], value, onChange, style, ...rest }) {
  const classes = useStyles();
  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={value}
      onChange={(e, v) => v != null && onChange && onChange(v)}
      className={classes.group}
      style={style}
      {...rest}
    >
      {options.map((o) => {
        const val = typeof o === "string" ? o : o.value;
        const label = typeof o === "string" ? o : o.label;
        return (
          <ToggleButton key={val} value={val} className={classes.btn}>
            {label}
          </ToggleButton>
        );
      })}
    </ToggleButtonGroup>
  );
}
